/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, {useContext, useState} from 'react';
import {Button, Button2, Footer, Header, Surface, Tab, Text} from 'components';
import {BaseWrapper} from '../../styles';
import {ButtonContainer, ChangePasswordContainer} from './styles';
import {useHistory} from 'react-router-dom';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import {GlobalAuthContext, GlobalLoaderContext} from 'store/context';
import {Field, Form, Formik} from 'formik';
import {
  InputField,
  Label,
  MultiSelectField,
  Section,
  SectionHeader,
  SectionLegend,
  SectionTitle,
  SelectField,
} from 'components/Form';
import {Col, Row} from 'components/Grid';
import * as Yup from 'yup';
import {FitinsurAPI, MessageCenter} from 'utils';
import TopHeader from 'components/TopHeader/index';

export default function ChangePasswordPage() {
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const firstLoginState = authContext.firstLogin;
  const changePasswordLinkAnchor = (authContext.status == true && firstLoginState != true) ?? 'login';
  const changePasswordLinkText = (authContext.status == true && firstLoginState != true) ?? 'click here';
  const [changePasswordMessage, setChangePasswordMessage] = useState('Please enter your account information');

  const [changePasswordState, setChangePasswordState] = useState(
    authContext.changedPassword
  );

  return (
    <BaseWrapper>
      <TopHeader />
      <ChangePasswordContainer>
        <Header
          title='Changing Password'
          subtitle={changePasswordMessage}
          linkText={changePasswordLinkText}
          linkAnchor={changePasswordLinkAnchor}
        />

        <Formik
          initialValues={{
            username: authContext.username || '',
            password: '',
            new_password: '',
            new_password_confirm: '',
          }}
          validationSchema={Yup.object({
            username: Yup.string()
              .email('Invalid email')
              .required('* Required field'),
            password: Yup.string().required('* Required field'),
            new_password: Yup.string()
              .required('* Required field')
              .test(
                'match',
                'Current and new password cannot be equal',
                function (new_password) {
                  return new_password !== this.parent.password;
                }
              )
              .matches(
                /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\d]).*$/,
                "Your password must be at least 8 characters long and contain: 1 Uppercase letter, 1 Lowercase letter, 1 Special character and 1 digit."
              ),
            new_password_confirm: Yup.string()
              .required('* Required field')
              .test(
                'match',
                'Passwords do not match',
                function (new_password_confirm) {
                  return new_password_confirm == this.parent.new_password;
                }
              ),
          })}
          onSubmit={(values) => {
            loading.start();
            const fitinsur = new FitinsurAPI();

            fitinsur
              .requestChangePassword(
                values.username,
                values.password,
                values.new_password
              )
              .then((response) => response.json())
              .then((data) => {
                authContext.login_response = data;
                if (data.ret_code === 200) {
                  authContext.status = false;
                  authContext.username = values.username;
                  authContext.person_product = data.ret_person_product;
                  authContext.user_region = data.ret_user_region;
                  authContext.firstLogin = false;
                  authContext.changedPassword = true;
                  if (data.ret_value.token) authContext.token = data.ret_value.token;

                  history.push('login');

                  /* 
                  setChangePasswordMessage('Your password was changed sucessfully, to proceed with the login, please ');
                  setChangePasswordLinkText('click here');
                  setChangePasswordLinkAnchor('login');
                  setChangePasswordState(true);
                  setFirstLoginState(false);
                  */
                } else {
                  authContext.status = false;
                  authContext.username = values.username;
                  authContext.token = '';
                  authContext.person_product = [];
                  authContext.user_region = '';
                  authContext.firstLogin = false;
                  authContext.changedPassword = false;

                  setChangePasswordMessage('Error changing password');
                  setChangePasswordState(false);
                }
                Header.subtitle = changePasswordMessage;
                loading.stop();
              })
              .catch(() => {
                authContext.status = false;
                authContext.username = values.username;
                authContext.token = '';
                authContext.person_product = [];
                authContext.user_region = '';
                authContext.firstLogin = false;
                authContext.changedPassword = false;

                setChangePasswordMessage('Error changing password');
                setChangePasswordState(false);
                loading.stop();
              });
          }}
        >
          {(props) => (
            <Form>
              <Surface>
                <Section>
                  <Row>
                    <Col xs={12} md={8}>
                      <Field
                        name='username'
                        label='E-mail:'
                        type='text'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        originalSize
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={8}>
                      <Field
                        name='password'
                        label='Current password:'
                        type='password'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={8}>
                      <Field
                        name='new_password'
                        label='New password:'
                        type='password'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={8}>
                      <Field
                        name='new_password_confirm'
                        label='Confirm your new password:'
                        type='password'
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        /* disabled={changePasswordState == true && firstLoginState != true} */
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={12} style={{ position: 'static' }}>
                      <ButtonContainer>
                        <Button
                          primary
                          type='submit'
                          id='btnChangePassword'
                          style={{}}
                          /* disabled={changePasswordState == true && firstLoginState != true} */
                        >
                          Next
                        </Button>
                      </ButtonContainer>
                    </Col>
                  </Row>
                </Section>
              </Surface>
            </Form>
          )}
        </Formik>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ChangePasswordContainer>
      <Footer />
    </BaseWrapper>
  );
}
